<template>
  <el-dialog
    title="Deposit"
    :visible="dialog_deposit"
    width="500px"
    top="3vh"
    :modal="true"
    @close="closeModal"
  >
    <el-input
      type="number"
      v-model="deposit"
      clearable
      placeholder="Insert number..."
    />
    <div class="mt20">
      <el-checkbox v-model="returnDeposit">Return</el-checkbox>
    </div>
    <div slot="footer">
      <el-button type="primary" size="mini" @click="depositVidcents">
        Save
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'

export default {
  data() {
    return {
      deposit: null,
      returnDeposit: false
    }
  },

  computed: {
    ...mapState('vcTrack', ['dialog_deposit'])
  },

  methods: {
    ...mapActions('vcTrack', ['depositTrack']),
    ...mapMutations('vcTrack', ['setTrackDeposit']),

    depositVidcents() {
      this.depositTrack({
        deposit: this.deposit,
        returnDeposit: this.returnDeposit
      })
      this.deposit = null
    },
    closeModal() {
      this.setTrackDeposit(false)
      this.deposit = null
      this.returnDeposit = false
    }
  }
}
</script>
